import type { FunctionComponent } from 'react'
import { Phone } from 'lucide-react'
import { normalizePhone } from '@playbooks/action-cards-utils'

type Props = {
  phone?: string
  className?: string
}

const CallButton: FunctionComponent<Props> = ({ phone, className = '' }) => {
  return (
    <a
      href={phone ? `tel:${normalizePhone(phone)}` : '#'}
      className={`flex items-center justify-center size-4.5 ${className}`}
    >
      <Phone />
    </a>
  )
}

export default CallButton
